import { useTranslation } from 'react-i18next';
import { useNavigate } from 'react-router-dom';
import BenefitInfoPanel from '../../../component/benefitTabs/BenefitInfoPanel';
import itLeasingOfficeBackground from '/image/itLeasing/it-leasing-office-background.jpg';

const ITLeasingInfoPanel: React.FC = () => {
  const navigate = useNavigate();
  const { t } = useTranslation('benefitsModule');

  return (
    <BenefitInfoPanel
      backgroundImage={itLeasingOfficeBackground}
      title={t('IT_LEASING.info.title')}
      description={t('IT_LEASING.info.description')}
      primaryButtonLabel={t('IT_LEASING.info.learnMore')}
      onPrimaryClick={() => navigate('/benefits/it_leasing/learnMore')}
      secondaryButtonLabel={t('IT_LEASING.info.connected')}
      onSecondaryClick={() => navigate('/benefits/it_leasing/connect')}
    />
  );
};
export default ITLeasingInfoPanel;
